// @ts-nocheck
import React, { FC } from 'react';
import { Item, Menu, useContextMenu } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.css';
import { savePDF } from '../../utils';
import { Button, Flex } from '.';
import FileSaver from 'file-saver';
import { SCREEN } from '../../theme/breakpoints';

const isWeb = SCREEN.isWeb;

interface Props {
  json: any;
  data: any;
  exportPDFTitle: any;
  id: string;
  showExportButton: boolean;
}

const SubmissionsPDF: FC<Props> = ({ exportPDFTitle, json, data, id, showExportButton = false }) => {
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const contextMenu = useContextMenu();

  const getAndSaveFilesInAZipFile = (data: any) => {
    const files: any = [];
    if (data) {
      Object.entries(data).forEach(([key, value]: any) => {
        if (!key.startsWith('tag')) {
          if (value && value[0] && value[0].content && value[0].name && value[0].type) {
            files.push(value[0]);
          }
        }
      });
    }

    if (files.length > 0) {
      const zip = window.JSZip();

      files.forEach((file: any, index: any) => {
        const base64Parts = file.content.split(';base64,');
        const base64String = base64Parts[1];

        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const fileName = file.name;

        const fileBlob = new Blob([byteArray], { type: file.type });

        zip.file(fileName, fileBlob);
      });

      zip.generateAsync({ type: 'blob' }).then((content: any) => {
        FileSaver.saveAs(content, 'Attachments.zip');
      });
    }
  };

  const handleExport = ({ exportFilled }: { exportFilled: boolean }) => {
    setShowModal(!showModal);
    savePDF({ json, data, exportFilled });
  };

  return (
    <>
      <Menu id={id}>
        <Item
          onClick={() => {
            handleExport({ exportFilled: false });
          }}
        >
          Blank Form
        </Item>
        <Item
          onClick={() => {
            handleExport({ exportFilled: true });
          }}
        >
          Completed Form
        </Item>
        <Item
          onClick={() => {
            getAndSaveFilesInAZipFile(data);
          }}
        >
          Attachments
        </Item>
      </Menu>
      {showExportButton && (
        <Flex direction="row" justify={isWeb ? 'flex-end' : 'right'}>
          <Button
            text="Export to PDF"
            type="button"
            onClick={e => {
              contextMenu.show(e, { id });
            }}
            maxWidth={isWeb ? '40px' : '100%'}
          />
        </Flex>
      )}
    </>
  );
};

export default SubmissionsPDF;
